export interface ICompanyConfigResponse {
  steps: string[],
  requiredFields: number[]
}

export default class CompanyDataResponse implements ICompanyConfigResponse {
  steps: string[];
  requiredFields: number[];

  constructor() {
      this.steps = [];
      this.requiredFields = [];
  }
}

export const QUESTIONID = {
  companyLegalName: 129,
  companyDoingBusinessAs: 130,
  companyParentCompany: 128,
  companyWebsite: 133,
  companyPhoneNumber: 134,
  companyEmailAddress: 136,
  companyTaxIdNumber: 131,
  dunsNumber: 132,
  primaryNAICSCode: 137,
  secondaryNAICSCode: 138,
  yearCompanyWasFounded: 127,
  numberOfPermanentEmployees: 126,
  unionizedCompany: 125,
  supplierCompanyOwnership: 109
}

interface IAnnualSale {
  [key: number]: number
}

/*
  MAINTENANCE REQUIRED: Annual sale question IDs by year (2009-2040)
  
  To add a new year:
  1. Check the eip.surveyquestion and eip.sectionquesassoc tables for the new question ID
  2. Add the year-to-ID mapping to this ANNUAL_SALE object
  3. Update the corresponding array in [full/path/to]/QuestionnaireConfigurationPanel.js in EIP.
  
  Note: If the question ID doesn't exist in the database, it must be created first.
*/

export const ANNUAL_SALE: IAnnualSale = {
  2009: 105,
  2010: 104,
  2011: 103,
  2012: 156,
  2013: 645,
  2014: 647,
  2015: 652,
  2016: 653,
  2017: 654,
  2018: 655,
  2019: 656,
  2020: 665,
  2021: 666,
  2022: 667,
  2023: 668,
  2024: 669,
  2025: 670,
  2026: 671,
  2027: 672,
  2028: 673,
  2029: 674,
  2030: 675,
  2031: 679,
  2032: 680,
  2033: 681,
  2034: 682,
  2035: 683,
  2036: 684,
  2037: 685,
  2038: 686,
  2039: 687,
  2040: 688
};

export const variableSteps = ["BusinessInfo", "Diversity", "Products"];

